import { useLocation } from 'react-router-dom'
import React, { useEffect } from 'react'
import './Articles.css'
import banner from '../../assets/images/Articles Banner.png'
import { Link } from 'react-router-dom'
import aos from 'aos';
import 'aos/dist/aos.css'

const Articles = () => {
    const { top } = useLocation();
    useEffect(()=>{
      aos.init({ duration: 1000 });
      window.scrollTo(0,0);
    },[top])

    return (
        <>
            <div className="container-fluid gx-0">
                <img className='img-fluid' data-aos="zoom-in" src={banner} alt="" />
            </div>
            <div className="container py-lg-5 py-3">
                <div className="row">
                    <div className="col-lg-4 pe-5">
                        <h6 className='industries-heading' data-aos="zoom-in">Industries</h6><hr className='industries-hr'/>
                        <ul className='all-link-container' data-aos="zoom-in">
                            <li><Link className='articles-link'>Micro, Small & Medium Enterprises</Link></li><hr/>
                            <li><Link className='articles-link'>Mining</Link></li><hr/>
                            <li><Link className='articles-link'>Chemicals and Petrochemicals</Link></li><hr/>
                            <li><Link className='articles-link'>Corporate Governance</Link></li><hr/>
                            <li><Link className='articles-link'>Cottage</Link></li><hr/>
                            <li><Link className='articles-link'>Defence Products</Link></li><hr/>
                            <li><Link className='articles-link'>Fertilizers</Link></li><hr/>
                        </ul>

                    </div>
                    <div className="col-lg-8">
                        <h5 className='articles-heading' data-aos="zoom-in">Pharmaceuticals Articles</h5><hr/>
                        <div className="row pt-3">
                            <div className="articles-content" data-aos="zoom-in">
                                <h6 >Information on Indian Pharmacopoeia Commission</h6>
                                <div className='share-container'>
                                   <Link className='share-link'><i className="bi bi-tags"></i><span>suggest Tags</span></Link>
                                   <Link className='share-link'> <i className="bi bi-chat"></i><span>Comment</span></Link>
                                    <Link className='share-link'><i className="bi bi-share"></i><span>Share This</span></Link>
                                </div>
                                <p>The Indian Pharmacopoeia Commission (IPC) is an autonomous institution under the Ministry of Health and Family Welfare which is responsible to set standards of drugs in the country. Details of Indian Pharmacopoeia (IP) such as Monographs inclusion-exclusion criteria, development of IP Monograph, guideline for formatting of Monographs, IP review process, distribution network for IP etc. are...</p>
                            </div>
                        </div>
                        <div className="row pt-3">
                            <div className="articles-content" data-aos="zoom-in">
                                <h6>Information on Current Research & Information on Pharmaceutical Sciences</h6>
                                <div className='share-container'>
                                   <Link className='share-link'><i className="bi bi-tags"></i><span>suggest Tags</span></Link>
                                   <Link className='share-link'> <i className="bi bi-chat"></i><span>Comment</span></Link>
                                    <Link className='share-link'><i className="bi bi-share"></i><span>Share This</span></Link>
                                </div>
                                <p>Get information about the Current Research & Information on Pharmaceutical Sciences, under National Institute of Pharmaceutical Education and Research (NIPER). Current Research & Information on Pharmaceutical Sciences (CRIPS), a quarterly publication of NIPER aims to provide the latest pharmaceutical updates in current R&D technologies, regulations and education to the industry R...</p>
                            </div>
                        </div>

                        <div className="row pt-3">
                            <div className="articles-content" data-aos="zoom-in">
                                <h6>NPPA integrated management information system</h6>
                                <div className='share-container'>
                                   <Link className='share-link'><i className="bi bi-tags"></i><span>suggest Tags</span></Link>
                                   <Link className='share-link'> <i className="bi bi-chat"></i><span>Comment</span></Link>
                                    <Link className='share-link'><i className="bi bi-share"></i><span>Share This</span></Link>
                                </div>
                                <p>Users can find the Integrated Management Information System provided by the National Pharmaceuticals Pricing Authority. This facility is available for general public, manufacturers, and state drug controllers. One can submit a complaint, check complaint status and can also check notified prices. Manufacturers can login to avail related services.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            

        </>
    )
}

export default Articles
